import { h } from 'preact'

export default function studyRewardNotificationStarView ({ earnedAStar }) {
  return earnedAStar && h('div', {
    class: 'reward-notification good'
  }, 'You just earned this week\'s star! ⭐️')
}
